<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-12">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">Transferências de Estoque</h3>
        </div>
        <div class="card-body">
          <div class="row d-flex align-items-end">
            <div class="form-group col-md-4">
              <label>Produto</label>
              <select
                required
                type="text"
                class="form-control"
                v-model="filtro.produto_id"
              >
                <option value="">Selecione:</option>
                <option
                  v-for="lista in lista_produtos"
                  :key="lista.id"
                  :value="lista.id"
                >
                  {{ lista.nome }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label class="col-md-12"> Data Inicio:</label>
              <input
                required
                type="date"
                class="form-control"
                v-model="filtro.data_inicio"
              />
            </div>
            <div class="form-group col-md-3">
              <label class="col-md-12"> Data Fim:</label>
              <input
                required
                type="date"
                class="form-control"
                v-model="filtro.data_fim"
              />
            </div>

            <div class="form-group col-md-2 justify-content-end row">
              <div class="ml-1">
                <button
                  class="btn btn-success"
                  @click="listar_transferencias()"
                >
                  <i class="fa fa-search search-icon m-0 p-0"></i>
                </button>
              </div>

              <div class="ml-1">
                <!-- <div class="dropdown show">
                  <a class="btn btn-info" data-toggle="dropdown">
                    <i class="fa fa-print m-0 p-0"></i> Imprimir
                  </a>

                  <div class="dropdown-menu">
                    <a class="dropdown-item"  @click="gerarExcel()">Excel</a>
                    <a class="dropdown-item"  @click="gerarExcel()">PDF</a>
                  </div>
                </div> -->
                <b-dropdown id="dropdown-1" variant="info" text="Imprimir">
                  <b-dropdown-item @click="gerarExcel()">Excel</b-dropdown-item>
                  <b-dropdown-item @click="gerarPDF()">PDF</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>

          <b-table
            :fields="[
              'created',
              'produto',
              'descricao',
              'lote',
              'filial_antiga',
              'filial_atual',
              'quantidade',
              'acoes',
            ]"
            :items="lista_transferencias"
            :per-page="perPage"
            :current-page="currentPage"
            id="produto-table"
            class="table table-head-custom table-vertical-center table-head-bg table-borderless pt-1"
            show-empty
            empty-text="Nenhum registro encontrado!"
          >
            <template #head(acoes)><span></span></template>
            <template #cell(acoes)="{ item }">
              <div class="text-right w-100">
                <button
                  v-show="lista_permissoes_filial.u_Sala"
                  @click="showDetalhes(item)"
                  class="btn btn-icon btn-light btn-sm mx-1"
                  v-b-tooltip.hover
                  title="Ver mas detalhes"
                >
                  <i class="far fa-eye text-primary"></i>
                </button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="lista_produtos.length"
            :per-page="perPage"
            aria-controls="produto-table"
          >
          </b-pagination>
          <b-modal
            centered
            ref="detalhes"
            id="detalhes"
            title="Informaciones de la transferencia"
          >
            <div class="my-4 form">
              <div class="row">
                <div class="col-md-12">
                  <label for="sobrenome" class="col-md-12 text-"
                    >Usuario:
                  </label>
                </div>
              </div>
              <div class="row pt-1">
                <div class="col-md-6">
                  <label for="" class="col-md-12">Producto: </label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.produto"
                  />
                </div>
                <div class="col-md-6">
                  <label for="" class="col-md-12">Descripcion: </label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.descricao"
                  />
                </div>
              </div>
              <div class="row pt-3">
                <div class="col-md-4">
                  <label for="" class="col-md-12">Cantidad: </label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.quantidade"
                  />
                </div>
                <div class="col-md-4">
                  <label for="" class="col-md-12">Fecha </label>
                  <input
                    disabled
                    type="datetime"
                    class="form-control"
                    v-model="form.created"
                  />
                </div>
                <div class="col-md-4">
                  <label for="" class="col-md-12">Lote </label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.lote"
                  />
                </div>
              </div>
              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="" class="col-md-12">Filial Actual</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.filial_atual"
                  />
                </div>

                <div class="col-md-6">
                  <label for="" class="col-md-12">Filial Antigua</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="form.filial_antiga"
                  />
                </div>
              </div>
            </div>
            <template #modal-footer>
              <div class="row text-rigth w-100">
                <div class="col-md-6">
                  <button
                    v-show="lista_permissoes_filial.u_Sala"
                    @click="confirm(form.id)"
                    class="btn btn-danger"
                  >
                    Deshacer transferencia
                  </button>
                </div>

                <div class="col-md-2">
                  <button @click="fechar" class="btn btn-light">
                    Cerrar
                  </button>
                </div>
              </div>
            </template>
          </b-modal>
        </div>
        <div class="card-footer text-center text-grey">
          <h5>{{ $t("TRANSFERENCIA.TOTAL") }}: {{ soma_quantidade }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import { fireAlert } from "@/core/mixins/alertMessageMixin";
export default {
  mixins: { fireAlert },
  data() {
    return {
      filtro: {
        produto_id: null,
        data_inicio: null,
        data_fim: null,
      },
      form: [],
      soma_quantidade: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Relatorio" }]);
  },
  created() {
    this.listar_produtos();
  },
  computed: {
    lista_produtos() {
      return this.$store.state.produto.lista_produtos;
    },
    lista_transferencias() {
      return this.$store.state.produto.lista_transferencias;
    },
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    mensagem_alert() {
      return this.$store.state.produto.mensagem_alert;
    },
  },
  methods: {
    async listar_transferencias() {
      this.soma_quantidade = 0;
      this.$store.dispatch("configEmpresa/MudarPreloader", true);
      await this.$store
        .dispatch("produto/listar_transferencias", this.filtro)
        .finally(() => {
          this.$store.dispatch("configEmpresa/MudarPreloader", false);
        });

      for (var items in this.lista_transferencias) {
        this.soma_quantidade =
          this.soma_quantidade + this.lista_transferencias[items].quantidade;
      }
    },

    async listar_produtos() {
      await this.$store.dispatch("produto/listar_produtos");
    },

    atualizar(value) {
      this.$router.push({
        name: "produtoDados",
        params: { produto_id: value.id },
      });
      // this.$store.dispatch("configEmpresa/atualizar", value);
      // localStorage.setItem('produto',JSON.stringify(value));
      // this.$store.dispatch("produto/listar_produto", value.id);
    },
    async confirm(id) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta acción eliminará la transferencia. La cantidad volverá a la sucursal original`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.desfazer_transferencia(id);
          }
        },
      });
    },
    async desfazer_transferencia(id) {
      console.log(id);
      await this.$store.dispatch("produto/desfazer_transferencia", id);
      console.log(this.mensagem_alert.message);
      this.listar_transferencias()
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      if(this.mensagem_alert.tipo == 'success'){
        this.$refs["detalhes"].hide();
      }
    },
    alertMessage(tipo, mensagem) {
      this.$fire({
        title: "Aviso",
        text: mensagem,
        type: tipo,
        timer: 3000,
      }).then((r) => {
        console.log(r.value);
      });
    },
    async gerarExcel() {
      this.$store.dispatch("configEmpresa/MudarPreloader", true);
      console.log(this.filtro);
      await this.$store.dispatch("produto/excel_transferencias", this.filtro);
      this.$store.dispatch("configEmpresa/MudarPreloader", false);
    },
    gerarPDF() {
      alert("Ainda nao disponivel :(");
    },

    showDetalhes(item) {
      this.$refs["detalhes"].show();
      this.form = item;
      console.log(this.form);
    },
    fechar() {
      this.$refs["detalhes"].hide();
    },
  },
};
</script>
  
  <style scoped>
.lista:hover {
  background-color: rgba(167, 183, 255, 0.705);
}
</style>